import { GET_SCRIPTS } from "../../@jumbo/constants/ActionTypes";

const INIT_STATE = {
  dataScripts: [],
  isLoadedScripts: false
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_SCRIPTS: {
      return {
        ...state,
        dataScripts: action.payload,
        isLoadedScripts: true
      };
    }
    default:
      return state;
  }
};
